import { useTranslation } from '../../../utils/useTranslation';
import { IconInfoBold } from '../../icon/IconInfoBold';
import { FlexProps } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { Wrapper } from './styles';

export const BusinessStatisticDisclaimer = (props: FlexProps) => {
    const t = useTranslation();

    return (
        <Wrapper {...props}>
            <IconInfoBold color="var(--color-primary)" />
            <Typography variant="body2">
                {t(
                    'Обновили подсчёт показов в Ритме. С 25 мая показ засчитывается, если пост находится в видимой зоне экрана пользователя не менее 2 секунд.',
                )}
            </Typography>
        </Wrapper>
    );
};
